import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from React Router
import backgroundImage from '../assets/stream.jpg'; // Import the image

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogin = async (e) => {
    e.preventDefault();

    const loginData = {
      username,
      password,
    };

    try {
      // Mock backend request
      const response = await mockLoginRequest(loginData);

      if (response.success) {
        alert('Login successful!');
        navigate('/add'); // Redirect to another route on success
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError('An unexpected error occurred.');
    }
  };

  // Mock login request function
  const mockLoginRequest = async (data) => {
    // Define the valid credentials
    const validCredentials = [
      { username: 'gades', password: 'timo' },
      { username: 'cre8tiveD', password: 'david' },
      { username: 'kontv', password: 'realkontv' },

    ];

    // Check if the provided username and password match any of the valid credentials
    const isValid = validCredentials.some(
      (cred) => cred.username === data.username && cred.password === data.password
    );

    // Mock response based on the validity of the credentials
    const mockResponse = {
      success: isValid,
      message: isValid ? 'Login successful' : 'Invalid username or password',
    };

    // Simulate a network request with a delay
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockResponse), 1000);
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <h1 className='text-white font-black text-5xl'>ADMIN LOGIN</h1>
      <div className="w-full max-w-md bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <h2 className="text-center text-2xl font-bold text-gray-800 mb-6">Login</h2>
        {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Username
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
